"use client";

import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface FormSectionProps {
	title: string;
	icon: ReactNode;
	children: ReactNode;
	className?: string;
}

export const FormSection = ({
	title,
	icon,
	children,
	className,
}: FormSectionProps) => {
	return (
		<div className={cn("border border-border bg-cream rounded-xl p-6", className)}>
			<h4 className="font-display text-base font-semibold text-ink mb-4 flex items-center gap-2">
				<span className="text-terracotta">{icon}</span>
				{title}
			</h4>
			{children}
		</div>
	);
};
